export const data = [
  {
    pluginFamily: 'AIX Local Security Checks',
    pluginID: '*',
    'NIST-ID': 'SI-2|RA-5'
  },
  {
    pluginFamily: 'Amazon Linux Local Security Checks',
    pluginID: '*',
    'NIST-ID': 'SI-2|RA-5'
  },
  {
    pluginFamily: 'CentOS Local Security Checks',
    pluginID: '*',
    'NIST-ID': 'SI-2|RA-5'
  },
  {
    pluginFamily: 'Debian Local Security Checks',
    pluginID: '*',
    'NIST-ID': 'SI-2|RA-5'
  },
  {
    pluginFamily: 'F5 Networks Local Security Checks',
    pluginID: '*',
    'NIST-ID': 'SI-2|RA-5'
  },
  {
    pluginFamily: 'Fedora Local Security Checks',
    pluginID: '*',
    'NIST-ID': 'SI-2|RA-5'
  },
  {
    pluginFamily: 'FreeBSD Local Security Checks',
    pluginID: '*',
    'NIST-ID': 'SI-2|RA-5'
  },
  {
    pluginFamily: 'Gentoo Local Security Checks',
    pluginID: '*',
    'NIST-ID': 'SI-2|RA-5'
  },
  {
    pluginFamily: 'HP-UX Local Security Checks',
    pluginID: '*',
    'NIST-ID': 'SI-2|RA-5'
  },
  {
    pluginFamily: 'Huawei Local Security Checks',
    pluginID: '*',
    'NIST-ID': 'SI-2|RA-5'
  },
  {
    pluginFamily: 'Junos Local Security Checks',
    pluginID: '*',
    'NIST-ID': 'SI-2|RA-5'
  },
  {
    pluginFamily: 'MacOS X Local Security Checks',
    pluginID: '*',
    'NIST-ID': 'SI-2|RA-5'
  },
  {
    pluginFamily: 'Mandriva Local Security Checks',
    pluginID: '*',
    'NIST-ID': 'SI-2|RA-5'
  },
  {
    pluginFamily: 'NewStart CGSL Local Security Checks',
    pluginID: '*',
    'NIST-ID': 'SI-2|RA-5'
  },
  {
    pluginFamily: 'Oracle Linux Local Security Checks',
    pluginID: '*',
    'NIST-ID': 'SI-2|RA-5'
  },
  {
    pluginFamily: 'OracleVM Local Security Checks',
    pluginID: '*',
    'NIST-ID': 'SI-2|RA-5'
  },
  {
    pluginFamily: 'Palo Alto Local Security Checks',
    pluginID: '*',
    'NIST-ID': 'SI-2|RA-5'
  },
  {
    pluginFamily: 'PhotonOS Local Security Checks',
    pluginID: '*',
    'NIST-ID': 'SI-2|RA-5'
  },
  {
    pluginFamily: 'Red Hat Local Security Checks',
    pluginID: '*',
    'NIST-ID': 'SI-2|RA-5'
  },
  {
    pluginFamily: 'Scientific Linux Local Security Checks',
    pluginID: '*',
    'NIST-ID': 'SI-2|RA-5'
  },
  {
    pluginFamily: 'Slackware Local Security Checks',
    pluginID: '*',
    'NIST-ID': 'SI-2|RA-5'
  },
  {
    pluginFamily: 'Solaris Local Security Checks',
    pluginID: '*',
    'NIST-ID': 'SI-2|RA-5'
  },
  {
    pluginFamily: 'SuSE Local Security Checks',
    pluginID: '*',
    'NIST-ID': 'SI-2|RA-5'
  },
  {
    pluginFamily: 'Ubuntu Local Security Checks',
    pluginID: '*',
    'NIST-ID': 'SI-2|RA-5'
  },
  {
    pluginFamily: 'VMware ESX Local Security Checks',
    pluginID: '*',
    'NIST-ID': 'SI-2|RA-5'
  },
  {
    pluginFamily: 'Virtuozzo Local Security Checks',
    pluginID: '*',
    'NIST-ID': 'SI-2|RA-5'
  },
  {
    pluginFamily: 'Firewalls',
    pluginID: 56310,
    'NIST-ID': 'SC-7'
  },
  {
    pluginFamily: 'General',
    pluginID: 133964,
    'NIST-ID': 'AC-3(4)'
  },
  {
    pluginFamily: 'General',
    pluginID: 117530,
    'NIST-ID': 'UM-1'
  },
  {
    pluginFamily: 'General',
    pluginID: 110483,
    'NIST-ID': 'CM-7'
  },
  {
    pluginFamily: 'General',
    pluginID: 95928,
    'NIST-ID': 'AC-2'
  },
  {
    pluginFamily: 'General',
    pluginID: 90191,
    'NIST-ID': 'CM-8'
  },
  {
    pluginFamily: 'General',
    pluginID: 86420,
    'NIST-ID': 'CM-8'
  },
  {
    pluginFamily: 'General',
    pluginID: 70544,
    'NIST-ID': 'AC-17(2)|SC-13'
  },
  {
    pluginFamily: 'General',
    pluginID: 66334,
    'NIST-ID': 'SI-2|RA-5'
  },
  {
    pluginFamily: 'General',
    pluginID: 64582,
    'NIST-ID': 'CM-8'
  },
  {
    pluginFamily: 'General',
    pluginID: 57582,
    'NIST-ID': 'SC-12'
  },
  {
    pluginFamily: 'General',
    pluginID: 57041,
    'NIST-ID': 'AC-17(2)|SC-13'
  },
  {
    pluginFamily: 'General',
    pluginID: 56984,
    'NIST-ID': 'AC-17(2)|SC-13'
  },
  {
    pluginFamily: 'General',
    pluginID: 56468,
    'NIST-ID': 'CM-8'
  },
  {
    pluginFamily: 'General',
    pluginID: 55472,
    'NIST-ID': 'CM-8'
  },
  {
    pluginFamily: 'General',
    pluginID: 54615,
    'NIST-ID': 'CM-8'
  },
  {
    pluginFamily: 'General',
    pluginID: 51192,
    'NIST-ID': 'SC-12'
  },
  {
    pluginFamily: 'General',
    pluginID: 45590,
    'NIST-ID': 'CM-8'
  },
  {
    pluginFamily: 'General',
    pluginID: 45432,
    'NIST-ID': 'CM-8'
  },
  {
    pluginFamily: 'General',
    pluginID: 45410,
    'NIST-ID': 'SC-12'
  },
  {
    pluginFamily: 'General',
    pluginID: 39520,
    'NIST-ID': 'SI-2|RA-5'
  },
  {
    pluginFamily: 'General',
    pluginID: 35351,
    'NIST-ID': 'CM-8'
  },
  {
    pluginFamily: 'General',
    pluginID: 34098,
    'NIST-ID': 'CM-8'
  },
  {
    pluginFamily: 'General',
    pluginID: 33276,
    'NIST-ID': 'CM-8'
  },
  {
    pluginFamily: 'General',
    pluginID: 25220,
    'NIST-ID': 'SC-8'
  },
  {
    pluginFamily: 'General',
    pluginID: 25203,
    'NIST-ID': 'CM-8'
  },
  {
    pluginFamily: 'General',
    pluginID: 25202,
    'NIST-ID': 'CM-8'
  },
  {
    pluginFamily: 'General',
    pluginID: 22869,
    'NIST-ID': 'CM-8'
  },
  {
    pluginFamily: 'General',
    pluginID: 21643,
    'NIST-ID': 'AC-17(2)|SC-13'
  },
  {
    pluginFamily: 'General',
    pluginID: 12053,
    'NIST-ID': 'CM-8'
  },
  {
    pluginFamily: 'General',
    pluginID: 11936,
    'NIST-ID': 'CM-8'
  },
  {
    pluginFamily: 'General',
    pluginID: 10881,
    'NIST-ID': 'AC-17(2)|SC-13'
  },
  {
    pluginFamily: 'General',
    pluginID: 10863,
    'NIST-ID': 'SC-12'
  },
  {
    pluginFamily: 'General',
    pluginID: 10287,
    'NIST-ID': 'CM-8'
  },
  {
    pluginFamily: 'General',
    pluginID: 10114,
    'NIST-ID': 'CM-6'
  },
  {
    pluginFamily: 'Misc.',
    pluginID: 118237,
    'NIST-ID': 'CM-8'
  },
  {
    pluginFamily: 'Misc.',
    pluginID: 97993,
    'NIST-ID': 'CM-8'
  },
  {
    pluginFamily: 'Misc.',
    pluginID: 90707,
    'NIST-ID': 'CM-8'
  },
  {
    pluginFamily: 'Misc.',
    pluginID: 84821,
    'NIST-ID': 'AC-17(2)|SC-13'
  },
  {
    pluginFamily: 'Misc.',
    pluginID: 83875,
    'NIST-ID': 'AC-17(2)|SC-13'
  },
  {
    pluginFamily: 'Misc.',
    pluginID: 70657,
    'NIST-ID': 'AC-17(2)|SC-13'
  },
  {
    pluginFamily: 'Misc.',
    pluginID: 58651,
    'NIST-ID': 'AC-17'
  },
  {
    pluginFamily: 'Port scanners',
    pluginID: 14272,
    'NIST-ID': 'CM-8'
  },
  {
    pluginFamily: 'RPC',
    pluginID: 53335,
    'NIST-ID': 'CM-8'
  },
  {
    pluginFamily: 'RPC',
    pluginID: 10223,
    'NIST-ID': 'CM-8'
  },
  {
    pluginFamily: 'Service detection',
    pluginID: 121010,
    'NIST-ID': 'AC-17(2)|SC-13'
  },
  {
    pluginFamily: 'Service detection',
    pluginID: 104743,
    'NIST-ID': 'AC-17(2)|SC-13'
  },
  {
    pluginFamily: 'Service detection',
    pluginID: 25221,
    'NIST-ID': 'CM-8'
  },
  {
    pluginFamily: 'Service detection',
    pluginID: 22964,
    'NIST-ID': 'CM-8'
  },
  {
    pluginFamily: 'Service detection',
    pluginID: 11111,
    'NIST-ID': 'CM-8'
  },
  {
    pluginFamily: 'Service detection',
    pluginID: 10884,
    'NIST-ID': 'AU-8(1)'
  },
  {
    pluginFamily: 'Service detection',
    pluginID: 10267,
    'NIST-ID': 'AC-17(2)'
  },
  {
    pluginFamily: 'Settings',
    pluginID: 117887,
    'NIST-ID': 'UM-1'
  },
  {
    pluginFamily: 'Settings',
    pluginID: 110095,
    'NIST-ID': 'UM-1'
  },
  {
    pluginFamily: 'Settings',
    pluginID: 19506,
    'NIST-ID': 'UM-1'
  },
  {
    pluginFamily: 'Web Servers',
    pluginID: 85805,
    'NIST-ID': 'SC-8|SC-13'
  },
  {
    pluginFamily: 'Web Servers',
    pluginID: 84502,
    'NIST-ID': 'AC-17(2)|SC-13'
  },
  {
    pluginFamily: 'Web Servers',
    pluginID: 43111,
    'NIST-ID': 'CM-8'
  },
  {
    pluginFamily: 'Web Servers',
    pluginID: 24260,
    'NIST-ID': 'CM-8'
  },
  {
    pluginFamily: 'Web Servers',
    pluginID: 10107,
    'NIST-ID': 'CM-8'
  }
];
